<template>
  <div>
    <div v-if="selectedBot.theme == 'powerbuy'">
      <v-radio-group row v-model="hasLinkUrl">
        <v-radio color="primary" label="มี Link URI" :value="true"></v-radio>
        <v-radio color="primary" label="ไม่มี Link URI" :value="false"></v-radio>
      </v-radio-group>
      <div
        v-if="hasLinkUrl === true"
        class="form-control"
        :class="{ 'has-error': errors.has('linkuri') }"
      >
        <input
          placeholder="Enter Link URL"
          name="linkuri"
          v-validate="'required|isUrl'"
          :data-vv-as="$t('Link URI')"
          v-model="linkurl"
          type="text"
        />
        <span class="text-error" v-if="errors.has('linkuri')">{{ errors.first('linkuri') }}</span>
      </div>
      <uploadfile @input="onUploaded" v-model="image_url"></uploadfile>
    </div>
    <div v-if="selectedBot.pageid == '102052945584054' || selectedBot.pageid == '106855151601601'">
      <uploadfile @input="onUploaded" v-model="image_url"></uploadfile>
      <v-radio-group row v-model="hasLinkUrl">
        <v-radio color="primary" label="ภาพอย่างเดียว" :value="false"></v-radio>
        <v-radio color="primary" label="Link URI" :value="true"></v-radio>
        <v-radio color="primary" label="Text" value="Text"></v-radio>
      </v-radio-group>
      <div
        v-if="hasLinkUrl === true"
        class="form-control"
        :class="{ 'has-error': errors.has('linkuri') }"
      >
        <input
          placeholder="Enter Link URL"
          name="linkuri"
          v-validate="'required|isUrl'"
          :data-vv-as="$t('Link URI')"
          v-model="linkurl"
          type="text"
        />
        <span class="text-error" v-if="errors.has('linkuri')">{{ errors.first('linkuri') }}</span>
      </div>
      <div
        v-if="hasLinkUrl === 'Text'"
        class="form-control"
        :class="{ 'has-error': errors.has('Text') || errors.has('Action') }"
      >
        <label for="Text">ระบุคำที่ลูกค้าเห็น</label>
        <input
          placeholder="Text"
          name="Text"
          v-validate="'required'"
          v-model="textlabel"
          type="text"
        />
        <span class="text-error" v-if="errors.has('Text')">{{ errors.first('Text') }}</span>
      </div>
    </div>
    <div class="col-12 w-100" v-else>
      <v-btn
        @click="showUploadFile = true"
        color="primary"
        :dark="showUploadFile"
        :outline="!showUploadFile"
        >อัพโหลดไฟล์</v-btn
      >
      <v-btn
        @click="showUploadFile = false"
        color="primary"
        :dark="!showUploadFile"
        :outline="showUploadFile"
        >JSON</v-btn
      >

      <template v-if="showUploadFile">
        <v-radio-group row v-model="hasLinkUrl">
          <v-radio color="primary" label="มี Link URI" :value="true"></v-radio>
          <v-radio color="primary" label="ไม่มี Link URI" :value="false"></v-radio>
        </v-radio-group>
        <v-flex xs12 class="form-control pa-1">
          <label for>Notify</label>
          <input
            type="text"
            placeholder="This is an imagemap"
            v-model.lazy="notify"
            class="form-control"
            maxlength="255"
          />
        </v-flex>
        <div
          v-if="hasLinkUrl === true"
          class="form-control"
          :class="{ 'has-error': errors.has('linkuri') }"
        >
          <label for>Url</label>
          <input
            placeholder="Enter Link URL"
            name="linkuri"
            v-validate="'required|isUrl'"
            :data-vv-as="$t('Link URI')"
            v-model="linkurl"
            type="text"
          />
          <span class="text-error" v-if="errors.has('linkuri')">{{ errors.first('linkuri') }}</span>
        </div>
        <uploadfile @input="onUploaded" v-model="image_url"></uploadfile>
      </template>
      <div v-else class="pt-3">
        <codemirror
          ref="cmCode"
          v-model="code"
          :options="cmOptions"
          @input="onCmCodeChange"
        ></codemirror>
      </div>
    </div>
    <div class="text-xs-center py-2 mt-4">
      <v-btn outline color="grey" @click="onCancel">{{ $t('cancel') }}</v-btn>
      <v-btn depressed color="primary" @click="onSave">{{ $t('Save') }}</v-btn>
    </div>
  </div>
</template>

<script>
import { codemirror } from 'vue-codemirror'

// require styles
import 'codemirror/lib/codemirror.css'
import 'codemirror/theme/base16-light.css'
// require active-line.js
import 'codemirror/addon/selection/active-line.js'
// closebrackets
import uploadfile from '@/components/elements/uploadfile.vue'
import 'codemirror/addon/display/autorefresh.js'
import 'codemirror/addon/edit/closebrackets.js'
import 'codemirror/addon/edit/matchbrackets.js'
import { mapGetters } from 'vuex'
export default {
  props: ['value', 'image_url_edit'],
  data: function () {
    return {
      image: {
        width: '',
        height: ''
      },
      notify: null,
      image_url: '',
      linkurl: '',
      hasLinkUrl: false,
      code: '',
      textlabel: '',
      // textaction: '',
      cmOptions: {
        // codemirror options
        tabSize: 4,
        mode: {
          name: 'javascript',
          json: true
        },
        lineNumbers: true,
        showCursorWhenSelecting: true,
        matchBrackets: true,
        styleSelectedText: true,
        styleActiveLine: true,
        theme: 'base16-light',
        line: true,
        autoFocus: true,
        autoRefresh: true
        // more codemirror options, 更多 codemirror 的高级配置...
      },
      showUploadFile: true
    }
  },
  components: {
    codemirror,
    uploadfile
  },
  mounted: function () {
    if (this.value) {
      this.code = this.value
      try {
        let jsonTemp = JSON.parse(this.value)
        this.notify = jsonTemp.altText ? jsonTemp.altText : null
      } catch (error) {
        this.notify = null
      }
    }
    if (this.image_url_edit) {
      var value = JSON.parse(this.value)
      var valuearea = value.actions[0].area
      if (valuearea.height == 1 && valuearea.width == 1) {
        this.hasLinkUrl = false
      } else {
        if (value.actions && value.actions[0] && value.actions[0].type == 'message') {
          this.hasLinkUrl = 'Text'
          this.textlabel = value.actions[0].text
        } else {
          this.hasLinkUrl = true
          this.linkurl = value.actions[0].linkUri
        }
      }
      this.image_url = this.image_url_edit.replace('?_ignored=', '')
    }
    var vm = this
    vm.$nextTick(() => {
      if (vm.$refs.cmCode && vm.$refs.cmCode.codemirror) {
        vm.$refs.cmCode.codemirror.refresh()
      }
      // cm.refresh()
    })
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },
  methods: {
    onCancel() {
      this.$emit('oncancel')
    },
    async onSave() {
      const vm = this
      let result = await vm.$validator.validateAll()
      if (result) {
        if (vm.showUploadFile) {
          var code = JSON.parse(vm.value)
          if (vm.hasLinkUrl && vm.hasLinkUrl == 'Text') {
            var newCode = {
              type: 'basicimagemap',
              baseUrl: code.baseUrl,
              altText: this.notify ? this.notify : 'This is an imagemap',
              baseSize: {
                width: code.baseSize.width,
                height: code.baseSize.height
              },
              actions: [
                {
                  type: 'message',
                  text: this.textlabel,
                  area: {
                    x: 0,
                    y: 0,
                    width: this.hasLinkUrl ? code.baseSize.width : 1,
                    height: this.hasLinkUrl ? code.baseSize.height : 1
                  }
                }
              ]
            }
          } else {
            var newCode = {
              type: 'basicimagemap',
              baseUrl: code.baseUrl,
              altText: this.notify ? this.notify : 'This is an imagemap',
              baseSize: {
                width: code.baseSize.width,
                height: code.baseSize.height
              },
              actions: [
                {
                  type: 'uri',
                  linkUri: this.hasLinkUrl ? this.linkurl : code.baseUrl,
                  area: {
                    x: 0,
                    y: 0,
                    width: this.hasLinkUrl ? code.baseSize.width : 1,
                    height: this.hasLinkUrl ? code.baseSize.height : 1
                  }
                }
              ]
            }
          }

          newCode = JSON.stringify(newCode)

          this.onCmCodeChange(newCode)
        }
        this.$emit('onsave')
      }
    },
    onUploaded(url, size) {
      var newCode = JSON.stringify({
        type: 'basicimagemap',
        baseUrl: url + '?_ignored=',
        altText: this.notify ? this.notify : 'This is an imagemap',
        baseSize: {
          width: size.width,
          height: size.height
        },
        actions: [
          {
            type: 'uri',
            linkUri: this.hasLinkUrl ? this.linkurl : url,
            area: {
              x: 0,
              y: 0,
              width: this.hasLinkUrl ? size.width : 1,
              height: this.hasLinkUrl ? size.height : 1
            }
          }
        ]
      })

      this.onCmCodeChange(newCode)
    },
    onCmCodeChange: function (newCode) {
      this.code = newCode
      this.$emit('input', this.code)
    }
  },
  watch: {
    value: function (newVal) {
      this.code = newVal
    }
  }
}
</script>

<style lang="scss" scoped>
.CodeMirror pre {
  white-space: pre-wrap;
  word-break: break-all;
  word-wrap: break-word;
}

.CodeMirror pre {
  height: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/view/intent/IntentLineImageMapMessage.vue